import backendURL from "./config";

export const form = async (name, mobile, city, message) => {
  const response = await backendURL.post("/contactus/register", {
    name,
    mobile,
    city,
    message,
  });
  return response.data.data;
};

export const viewForm = async (
  page,
  pageSize,
  searchTerm,
  startDate,
  endDate
) => {
  try {
    const response = await backendURL.post("contactus/view", {
      page,
      pageSize,
      searchTerm,
      startDate,
      endDate,
    });
    return response.data.data;
  } catch (error) {
    if (error.response) {
      if (error.response.status === 404) {
        throw new Error("No records found for the given criteria.");
      } else {
        throw new Error(error.response?.data?.message || "An error occurred.");
      }
    } else {
      throw new Error("Network error. Please try again later.");
    }
  }
};
